<div class="dialog-container">

    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 48 48">
                    <path fill="currentColor" fill-rule="evenodd"
                        d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0"
                        clip-rule="evenodd" />
                </svg>
            </div>
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>

    <section mat-dialog-content [formGroup]="evidenceForm">
        <form [formGroup]="evidenceForm">
            <div class="form-container">

                @if(!this.memberId){
                <div class="w-100 mt-2 mb-2">
                    <mat-form-field appearance="outline" class="search-field-agent">
                        <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                            </svg>
                        </span>
                        <input matInput placeholder="Search Applicants *" (click)="$event.stopPropagation()"
                            [formControl]="memberSearchControl" />
                    </mat-form-field>
                </div>
                <div class="user-list-scroll scroll-content mt-3" *ngIf="memberSearchControl.value">
                    <ng-container *ngIf="filteredPatients.length > 0;else noPatients">
                        <div class="user-card" *ngFor="let user of filteredPatients; let i = index" [ngClass]="{
    'selected': selectedUser === user,
    'border-bottom': selectedUser !== user
  }" (click)="selectUser(user)">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2">
                                    <div class="avatar">
                                        {{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}
                                    </div>
                                    <div class="user-details">
                                        <div class="fw-500 fs-12">{{ user.firstName }} {{ user.lastName }}</div>
                                        <div class="text-muted fs-10">{{ user.phone }}</div>
                                    </div>
                                </div>
                                <div *ngIf="selectedUser === user">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path fill="#64c54c" fill-rule="evenodd"
                                            d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                                            clip-rule="evenodd" stroke-width="0.1" stroke="#64c54c" />
                                    </svg>
                                </div>
                                <div *ngIf="selectedUser !== user">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                        <path fill="#0075C9"
                                            d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6"
                                            stroke-width="0.1" stroke="#0075C9" />
                                        <path fill="#0075C9"
                                            d="M8 11.5c-.28 0-.5-.22-.5-.5V5c0-.28.22-.5.5-.5s.5.22.5.5v6c0 .28-.22.5-.5.5"
                                            stroke-width="0.1" stroke="#0075C9" />
                                        <path fill="#0075C9"
                                            d="M11 8.5H5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5"
                                            stroke-width="0.1" stroke="#0075C9" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noPatients>
                        <div class="no-data fs-12">
                            No applicants found!!!
                        </div>
                    </ng-template>

                </div>
                }
                @else {
                <div class="request-info-container mb-3" *ngIf="selectedPatient">
                    <div class="avatar-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                            <path fill="#0075C9"
                                d="M17.438 21.937H6.562a2.5 2.5 0 0 1-2.5-2.5v-.827c0-3.969 3.561-7.2 7.938-7.2s7.938 3.229 7.938 7.2v.827a2.5 2.5 0 0 1-2.5 2.5M12 12.412c-3.826 0-6.938 2.78-6.938 6.2v.827a1.5 1.5 0 0 0 1.5 1.5h10.876a1.5 1.5 0 0 0 1.5-1.5v-.829c0-3.418-3.112-6.198-6.938-6.198m0-2.501a3.924 3.924 0 1 1 3.923-3.924A3.927 3.927 0 0 1 12 9.911m0-6.847a2.924 2.924 0 1 0 2.923 2.923A2.926 2.926 0 0 0 12 3.064" />
                        </svg>
                    </div>
                    <div class="request-text">
                        <div class="request-main">
                            Medical Evidence Requested For
                            <strong>{{ selectedPatient.firstName }} {{ selectedPatient.lastName }}</strong>
                        </div>
                        <div class="request-sub d-flex align-items-center gap-3">
                            <div>{{ selectedPatient.dateOfBirth | age }}</div>
                            <div class="text-muted">|</div> <!-- optional separator -->
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                    <g fill="none" stroke="#0075C9" stroke-linejoin="round" stroke-width="1.5">
                                        <path
                                            d="M6.4 4.76a7.92 7.92 0 0 1 11.2 11.2l-4.186 4.186a2 2 0 0 1-2.828 0L6.4 15.96a7.92 7.92 0 0 1 0-11.2Z" />
                                        <circle cx="12" cy="10.36" r="3" stroke-linecap="round" />
                                    </g>
                                </svg>
                                {{ selectedPatient.address }}
                            </div>
                        </div>
                    </div>
                </div>

                }

                <span class="fs-12 mt-2" style="color: #000000e3">Upload Documents *</span>

                <div class="form-field-container w-100 mt-2 mb-3">
                    <!-- File Upload (Drag & Drop or Select File) -->
                    <div class="fileupload-container d-flex w-100" style="flex-direction: column;" appDnd
                        (fileDropped)="isDismissable ? '' : onFileDropped($event)">
                        <input type="file" #fileDropRef id="fileDropRef2" (change)="onAdditional($event)"
                            [disabled]="isDismissable" multiple accept="image/*, application/pdf" hidden />

                        <label for="fileDropRef2" class="upload-label" [class.disabled]="isDismissable">
                            <div>
                                <span class="mb-2 fs-12">Drag and drop files here or click to upload</span>
                            </div>
                        </label>
                    </div>

                    <!-- Mobile Camera Scan -->
                    <!-- <div *ngIf="isMobile" class="mobile-scan mt-2">
                        <label for="cameraInput" class="camera-upload-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="1.5">
                                    <path
                                        d="M12.857 3.189h-1.714c-.681 0-1.022 0-1.331.094c-.274.083-.529.22-.75.401c-.25.205-.438.489-.816 1.056L7.103 6.454c-1.524 0-2.286 0-2.868.296a2.72 2.72 0 0 0-1.188 1.19c-.297.581-.297 1.343-.297 2.867v5.651c0 1.524 0 2.286.297 2.868c.26.512.677.928 1.188 1.189c.582.296 1.344.296 2.868.296h9.794c1.524 0 2.286 0 2.868-.296a2.72 2.72 0 0 0 1.188-1.19c.297-.581.297-1.343.297-2.867v-5.651c0-1.524 0-2.286-.297-2.868a2.72 2.72 0 0 0-1.188-1.189c-.582-.296-1.344-.296-2.868-.296L15.754 4.74c-.378-.567-.567-.85-.816-1.056a2.2 2.2 0 0 0-.75-.401c-.309-.094-.65-.094-1.331-.094" />
                                    <path d="M15.775 13.212a3.775 3.775 0 1 1-7.55 0a3.775 3.775 0 0 1 7.55 0" />
                                </g>
                            </svg>
                            &nbsp;Scan Using Camera
                        </label>
                        <input type="file" id="cameraInput" (change)="onAdditional($event)" accept="image/*"
                            capture="environment" hidden [disabled]="isDismissable" />
                    </div> -->

                    <!-- Display Uploaded Files -->
                    <div *ngIf="uploadedFiles.length > 0" class="uploaded-file-list mt-3">
                        <div *ngFor="let file of uploadedFiles; let i = index"
                            class="uploaded-file-item d-flex align-items-center justify-content-between">
                            <span>{{ file.name }}</span>
                            <button (click)="removeFile(i)" class="remove-file-button">✖</button>
                        </div>
                    </div>
                </div>



                <span class="fs-12" style="color: #000000e3">Comments</span>

                <div class="form-row mt-2">
                    <mat-form-field appearance="outline" class="form-field" style="height: 60px;">
                        <textarea matInput formControlName="comments"></textarea>
                    </mat-form-field>
                </div>




            </div>
        </form>
    </section>

    <div class="evidence-signature text-end mb-2 me-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 16">
            <path fill="#0075C9"
                d="M8.499 7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0zm.25-2a.749.749 0 1 1-1.499 0a.749.749 0 0 1 1.498 0M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8" />
        </svg>
        <small class="text-muted">
            Submitted by <strong class="text-dark">{{ userName }}</strong> on
            <time>{{ today | date: 'longDate' }}</time>.
        </small>
    </div>


    <section mat-dialog-actions class="d-flex justify-content-end">
        <div class="modal-buttons-container d-flex gap-2">
            <button class="secondaryBtn" (click)="closeDialog()">
                <span class="btnContent">Cancel</span>
            </button>
            <button class="primaryBtn" (click)="submitForm()"
                [disabled]="this.evidenceForm.invalid || uploadedFiles.length == 0">
                <span class="btnContent">Submit</span>
            </button>
        </div>
    </section>

</div>